import React from 'react';
import SelectionControlsGroupCore, {
  SelectionControlsGroupProps,
} from 'omakase/SelectionControls/SelectionControlsGroupCore';

/**
 * (Non-formik) Implementation of grouping behaviors for radio buttons.
 * Use RadioButton components as children.
 */
const RadioButtonGroup: React.FunctionComponent<SelectionControlsGroupProps> = ({
  children,
  ...rest
}) => {
  return (
    <SelectionControlsGroupCore type="radio" {...rest}>
      {children}
    </SelectionControlsGroupCore>
  );
};

export default RadioButtonGroup;
